var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-header",
        [
          _vm._v(" Manage Access Hosts "),
          _c("gg-text-field", {
            staticClass: "float-right",
            attrs: {
              placeholder: "Search...",
              "append-icon": "mdi-magnify",
              "hide-details": ""
            },
            model: {
              value: _vm.search,
              callback: function callback($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          })
        ],
        1
      ),
      _c(
        "gg-card-text",
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              search: _vm.search,
              loading: _vm.loading,
              items: _vm.mysqlRemoteHosts
            },
            scopedSlots: _vm._u([
              {
                key: "item.actions",
                fn: function fn(_ref) {
                  var item = _ref.item
                  return [
                    _c(
                      "gg-btn",
                      {
                        on: {
                          click: function click($event) {
                            return _vm.showDeleteModal(item.host)
                          }
                        }
                      },
                      [_vm._v(" Delete ")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("delete-host-modal", {
            attrs: {
              opened: _vm.deleteModalOpened,
              host: _vm.selectedHost
            },
            on: {
              close: _vm.closeDeleteModal,
              "host-deleted": _vm.reloadHosts
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }